
import {Component, Emit, Inject, Model, Prop, Provide, Vue, Watch} from 'vue-property-decorator';
@Component({})
export default class PersonalList extends Vue {
  private $api: any;
  private $cookie: any;
  private model: any;
  private dataList: any = [];
  private IsNone: boolean = false;
  private loading: boolean = true;
  private finished: boolean = false;

  // 初始化加载列表
  private async created() {
    this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在加载...',
    });
    const data = await this.$api.httpPost('membership/Monthlysummary/PostMonthlysummaryForOneUserInfo');
    if (data.Success) {
      if (data.Data && data.Data.length > 0) {
        this.IsNone = false;
        this.$toast.clear();
        this.dataList = data.Data;
        // for (const i of data.Data) {
        //   if (i.Code === this.$cookie.get('CURLOGINNAME')) {
        //     this.dataList.push(i);
        //   }
        // }
      } else {
        this.$toast.clear();
        this.IsNone = true;
      }
    } else {
      this.$toast.clear();
      this.$dialog.alert({
        title: '错误',
        message: data.AllMessages,
      });
    }
  }

  // 点击跳转详情页
  private async showInfo(item: any) {
    this.$router.push({ name: 'info-personal', query: { CId: item } });
  }
}
